import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '../avatar';

const defaultImages = [];

const AvatarList = ({ images = defaultImages, shift = 15 }) => (
  <div className="ws-difm-avatar-list" style={{ '--ws-difm-avatar-list-shift': `${-shift}px` }}>
    {images.map((src) => (
      <div key={src} className="ws-difm-avatar-list__item">
        <Avatar size={40} src={src} />
      </div>
    ))}
  </div>
);

AvatarList.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string),
  shift: PropTypes.number,
};

export default AvatarList;
